import React from 'react';
import { Button } from './button';
import { Download } from 'lucide-react';
import { exportRowsToCSV, exportRowsToExcel, exportRowsToPdfPrint } from '../../lib/tableExport';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';

export const TableControls = ({
  totalRows,
  page,
  totalPages,
  pageSize,
  pageSizes,
  onPageSizeChange,
  onPrevious,
  onNext,
  exportConfig,
}) => {
  const handleExportCsv = () => {
    if (!exportConfig) return;
    exportRowsToCSV({
      rows: exportConfig.rows || [],
      columns: exportConfig.columns || [],
      fileName: exportConfig.fileName || 'table-export.csv',
    });
  };

  const handleExportExcel = () => {
    if (!exportConfig) return;
    exportRowsToExcel({
      rows: exportConfig.rows || [],
      columns: exportConfig.columns || [],
      fileName: exportConfig.fileName || 'table-export.xls',
    });
  };

  const handleExportPdf = () => {
    if (!exportConfig) return;
    exportRowsToPdfPrint({
      rows: exportConfig.rows || [],
      columns: exportConfig.columns || [],
      title: exportConfig.title || 'Table Export',
    });
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-3 border-t">
      <div className="text-hr-xs text-muted-foreground">
        Showing page {page} of {totalPages} ({totalRows} rows)
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {exportConfig ? (
          <>
            <Button size="sm" variant="outline" onClick={handleExportCsv} className="h-8">
              <Download className="h-3.5 w-3.5 mr-1" />
              CSV
            </Button>
            <Button size="sm" variant="outline" onClick={handleExportExcel} className="h-8">
              <Download className="h-3.5 w-3.5 mr-1" />
              Excel
            </Button>
            <Button size="sm" variant="outline" onClick={handleExportPdf} className="h-8">
              <Download className="h-3.5 w-3.5 mr-1" />
              PDF
            </Button>
          </>
        ) : null}
        <span className="text-hr-xs text-muted-foreground">Rows:</span>
        <Select value={String(pageSize)} onValueChange={(value) => onPageSizeChange(parseInt(value, 10))}>
          <SelectTrigger className="h-8 w-[86px] text-hr-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {pageSizes.map((size) => (
              <SelectItem key={size} value={String(size)}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button size="sm" variant="outline" onClick={onPrevious} disabled={page <= 1}>
          Previous
        </Button>
        <Button size="sm" variant="outline" onClick={onNext} disabled={page >= totalPages}>
          Next
        </Button>
      </div>
    </div>
  );
};
